import { render } from "./PreferenceSelector.vue?vue&type=template&id=66b368c0&scoped=true"
import script from "./PreferenceSelector.vue?vue&type=script&lang=js"
export * from "./PreferenceSelector.vue?vue&type=script&lang=js"

import "./PreferenceSelector.vue?vue&type=style&index=0&id=66b368c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66b368c0"]])

export default __exports__